var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5072 8.35645H10.871C9.49258 8.35645 8.37109 9.47791 8.37109 10.8564V19.4925C8.37109 20.871 9.49258 21.9928 10.871 21.9928H19.5072C20.8856 21.9928 22.0075 20.8713 22.0075 19.4925V10.8564C22.0075 9.47791 20.886 8.35645 19.5072 8.35645ZM15.1891 19.6636C12.714 19.6636 10.7003 17.6499 10.7003 15.1745C10.7003 12.6994 12.714 10.6856 15.1891 10.6856C17.6645 10.6856 19.6783 12.6994 19.6783 15.1745C19.6783 17.6495 17.6642 19.6636 15.1891 19.6636ZM19.8226 11.6137C19.2367 11.6137 18.7602 11.1372 18.7602 10.5516C18.7602 9.96604 19.2367 9.48954 19.8226 9.48954C20.4082 9.48954 20.8847 9.96604 20.8847 10.5516C20.8847 11.1372 20.4082 11.6137 19.8226 11.6137Z",
    fill: "#91A4CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1899 12.582C13.7611 12.582 12.5977 13.7448 12.5977 15.1736C12.5977 16.6031 13.7611 17.7662 15.1899 17.7662C16.6194 17.7662 17.7819 16.6031 17.7819 15.1736C17.7819 13.7451 16.6191 12.582 15.1899 12.582Z",
    fill: "#91A4CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.49ede84de5e2858c51404b4e970d95c3.svg";
export { ForwardRef as ReactComponent };